import React from "react";
import { Select, FormControl, InputLabel } from "@mui/material";
import { Controller } from "react-hook-form";
import { forwardRef } from "react";

const ReactHookFormSelect = forwardRef((props, ref) => {
  return (
    <FormControl fullWidth>
      <InputLabel id={"select-label" + props.id}>{props.title}</InputLabel>
      <Controller
        render={({ field }) => (
          <Select
            size={props.size ?? "medium"}
            value={field.value}
            onChange={(e) => {
              field.onChange(e);
              props.onChange && props.onChange(e.target.value);
            }}
            inputRef={field.ref}
            fullWidth
            labelId={"select-label" + props.id}
            label={props.label}
            variant="outlined"
          >
            {props.children}
          </Select>
        )}
        name={props.id}
        control={props.control}
        defaultValue={props.defaultValue ?? ""}
      />
    </FormControl>
  );
});
export default ReactHookFormSelect;
